export default arn => arn && arn.split ? arn.split(':')[4] : undefined;
